const metaBuyingToolsUsers = [
  "berto.garciacarrillo@tinuiti.com",
  "brandon.huss@tinuiti.com",
  "carling.sugarman@tinuiti.com",
  "samuel.york@tinuiti.com",
  "ryan.che@tinuiti.com",
];

export const shouldEnableMetaBuyingTools = (user: string): boolean => {
  return metaBuyingToolsUsers.includes(user);
};
